var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzerbaijan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2511_3476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V32H32V0Z",
    fill: "#EF3340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 0H0V10.6664H32V0Z",
    fill: "#00B5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21.3336H0V32H32V21.3336Z",
    fill: "#509E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4103 20.75C17.0338 20.75 19.1605 18.6234 19.1605 16C19.1605 13.3766 17.0338 11.25 14.4103 11.25C11.7869 11.25 9.66016 13.3766 9.66016 16C9.66016 18.6234 11.7869 20.75 14.4103 20.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4663 19.9584C17.6525 19.9584 19.4248 18.1861 19.4248 16C19.4248 13.8139 17.6525 12.0417 15.4663 12.0417C13.2801 12.0417 11.5078 13.8139 11.5078 16C11.5078 18.1861 13.2801 19.9584 15.4663 19.9584Z",
    fill: "#EF3340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6878 13.3611L20.1928 14.781L21.5538 14.134L20.9069 15.495L22.3268 16L20.9069 16.5049L21.5538 17.8659L20.1928 17.219L19.6878 18.6389L19.1829 17.219L17.8218 17.8659L18.4688 16.5049L17.0488 16L18.4688 15.495L17.8218 14.134L19.1829 14.781L19.6878 13.3611Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2511_3476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzerbaijan);
export default __webpack_public_path__ + "static/media/Azerbaijan.eec4723e0c2d5d943be8a3f0f2f734a2.svg";
export { ForwardRef as ReactComponent };